<template>
  <q-btn flat icon="assignment_returned" v-if="value" @click="handleDownload"></q-btn>
</template>
<script>
// const API_BASE_URL = process.env.API_BASE_URL || 'https://api.ckc.mercurycreativegroup.com/api'

export default {
  name: 'grid-cell-file',
  props: {
    row: Object,
    column: {
      required: true,
      type: Object
    },
    value: {
      default: () => ''
    },
    id: {
      type: [String, Number]
    },
    resource: {
      type: String
    },
    css: {
      type: String,
      default: () => 'grid-image'
    }
  },
  methods: {
    async handleDownload () {
      this.$download(this.downloadUrl)
    }
  },
  computed: {
    downloadUrl () {
      return this.value
    }
  }
}
</script>
